import { createContext } from 'react';

export type Language = 'fr' | 'en' | 'zh';

export interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

/** Stable context reference — lives in its own module so Fast Refresh works on LanguageContext.tsx. */
export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
